import { useEffect, useState } from 'react';
import { useSearchParams, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { decryptResponseData } from '../services/EncryptService'; // encrypt/decrypt request response handling - st48236
import Cookies from 'js-cookie';
import { getCookieOptions } from '../utils/cookieUtils';

const SSOCheckAuthCallBack = () => {

    const [searchParams] = useSearchParams();
    const { setSSOAuthData } = useAuth();
    const [isSSOAuthenticated, setIsSSOAuthenticated] = useState(!!Cookies.get('authID'));
    // encrypt/decrypt request response handling - st48236 - start
    useEffect(() => {        
        const fetchDecryptedData = async () => {
            const queryString = searchParams.get('dataKey');            
            const decryptedDataKey = queryString ? await decryptResponseData(queryString) : null;
            const dataKey = decryptedDataKey ? btoa(decryptedDataKey) : null;
            if (dataKey) {
               setSSOAuthData(dataKey);
               setIsSSOAuthenticated(true);
            }
        };
        fetchDecryptedData();
    }, []);
    // encrypt/decrypt request response handling - st48236 - end

    const authId = Cookies.get('authID');
    const loggedId = authId ? JSON.parse(atob(authId)) : null;
    const appEnv = process.env.REACT_APP_ENVIRONMENT;
    const navigate = useNavigate();

    useEffect(() => {
        if(loggedId?.loggedId) {
           // If the environment is production, redirect to login page
            if(appEnv === 'PROD') {
                Cookies.set('region', process.env.REACT_APP_PROD_DB2_REGION, getCookieOptions()); // Default region for production;
                navigate('/login', { replace: true });
            }else if(appEnv === 'PFIX'){
                // If the environment is pre-fix, redirect to login page
                Cookies.set('region', process.env.REACT_APP_PFIX_DB2_REGION, getCookieOptions()); // Default region for pre-fix;
                navigate('/login', { replace: true });
            }else{
                // If the environment is not production, redirect to SlpMember page
                navigate('/SlpMember', { replace: true });
            } 
        }
    }, [appEnv, loggedId]);

    return(
        <div>
           <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <h1 className="mt-5">Redirecting...</h1>
                        <p>Please wait while we redirect you to the appropriate page.</p>
                    </div>
                </div>
            </div>
        </div>
    );
    
};

export default SSOCheckAuthCallBack;